import React, { Fragment } from "react";
import { string, shape, element, func, bool } from "prop-types";
import classNames from "classnames";
import ThemeConsumer from "../ThemeConsumer";

const ButtonInvoice = ({
  theme,
  image,
  preset,
  onClick,
  disabled,
  className,
  id
}) => {
  const classes = classNames(
    { [theme[preset]]: preset },
    { [theme.buttonImage]: !preset },
    className
  );

  return (
    <Fragment>
      <button
        id={id}
        type="button"
        className={disabled ? theme.buttonImageDisabled : classes}
        onClick={onClick}
      >
        <img src={image.type} alt="" />
      </button>
    </Fragment>
  );
};

ButtonInvoice.propTypes = {
  image: element.isRequired,
  preset: string,
  onClick: func,
  theme: shape({
    button: string
  }),
  disabled: bool,
  id: string
};

ButtonInvoice.defaultProps = {
  theme: {},
  onClick: null,
  preset: "buttonInvoice",
  disabled: false
};

export default ThemeConsumer("UIButtonInvoice")(ButtonInvoice);



// WEBPACK FOOTER //
// ./src/shared/components/Button/ButtonInvoice.js